var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_305)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 30,
    fill: "#0057FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24C37.7909 24 36 25.7909 36 28V49C36 51.2091 37.7909 53 40 53H55.2747C55.7543 53 56.23 53.0863 56.6792 53.2547L64 56V53V28C64 25.7909 62.2091 24 60 24H40ZM39.7929 43.7929C40.1822 43.4036 40.8126 43.4024 41.2034 43.7892L58.7963 43.7895L58.7935 43.7922L41.2037 43.7895L41.2173 43.8024C41.2322 43.8162 41.2584 43.8402 41.2962 43.873C41.3719 43.9385 41.4936 44.0389 41.6624 44.1629C41.9999 44.4108 42.525 44.7528 43.2452 45.0985C44.6819 45.7881 46.9097 46.5 50 46.5C53.0903 46.5 55.3181 45.7881 56.7548 45.0985C57.475 44.7528 58.0001 44.4108 58.3376 44.1629C58.5064 44.0389 58.6281 43.9385 58.7038 43.873C58.7416 43.8402 58.7678 43.8162 58.7827 43.8024L58.7935 43.7922H58.7936L58.7943 43.7915L58.7954 43.7904L58.7963 43.7895L58.7966 43.7892C58.7972 43.7886 58.7973 43.7886 58.7967 43.7891M58.7966 43.7892C59.1874 43.4024 59.8178 43.4036 60.2071 43.7929C60.5976 44.1834 60.5976 44.8166 60.2071 45.2071L59.5 44.5C60.2071 45.2071 60.2067 45.2075 60.2063 45.2079L60.2055 45.2087L60.2035 45.2106L60.1989 45.2153L60.1861 45.2278C60.176 45.2375 60.1629 45.2499 60.1468 45.265C60.1145 45.2951 60.0699 45.3356 60.013 45.3849C59.8992 45.4834 59.7358 45.6174 59.5218 45.7746C59.0937 46.0892 58.4625 46.4972 57.6202 46.9015C55.9319 47.7119 53.4097 48.5 50 48.5C46.5903 48.5 44.0681 47.7119 42.3798 46.9015C41.5375 46.4972 40.9063 46.0892 40.4782 45.7746C40.2642 45.6174 40.1008 45.4834 39.987 45.3849C39.9301 45.3356 39.8855 45.2951 39.8532 45.265C39.8371 45.2499 39.824 45.2375 39.8139 45.2278L39.8011 45.2153L39.7965 45.2106L39.7945 45.2087L39.7937 45.2079C39.7933 45.2075 39.7929 45.2071 40.5 44.5L39.7929 45.2071C39.4024 44.8166 39.4024 44.1834 39.7929 43.7929",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_305",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_305",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBtn);
export default __webpack_public_path__ + "static/media/chat_btn.8c1c36593b9bad136f54935ae23badd0.svg";
export { ForwardRef as ReactComponent };